import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 20px;
  background-color: ${(props) => props.theme.cardBg};
  border: 1px solid ${(props) => props.theme.border};
  border-radius: 12px;
  min-width: 0;
`;

const Label = styled.span`
  font-size: 12.5px;
  font-weight: 500;
  color: ${(props) => props.theme.secondaryTextColor};
`;

const Value = styled.span`
  font-size: 32px;
  font-weight: 650;
  line-height: 1.15;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: ${(props) => props.theme.textColor};
`;

const Extra = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid ${(props) => props.theme.border};
`;

// One headline number. Children render as detail rows under a divider.
const StatCard: React.FC<{
  label: React.ReactNode;
  value: React.ReactNode;
  children?: React.ReactNode;
}> = ({ label, value, children }) => {
  return (
    <Container>
      <Label>{label}</Label>
      <Value>{value}</Value>
      {children && <Extra>{children}</Extra>}
    </Container>
  );
};
export default StatCard;
